import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex w-full gap-10 mb-5" }
const _hoisted_2 = { style: {"min-width":"50px"} }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "mb-1 text-xs font-semibold color-blue-grey" }, "Saldo Saat Ini", -1)
const _hoisted_4 = { class: "flex gap-10" }
const _hoisted_5 = {
  class: "font-bold",
  style: {"font-size":"20px"}
}
const _hoisted_6 = { class: "" }
const _hoisted_7 = {
  key: 0,
  class: "pi pi-plus color-green text-2xl"
}
const _hoisted_8 = {
  key: 1,
  class: "pi pi-minus text-2xl",
  style: {"color":"#FF5F5F"}
}
const _hoisted_9 = { class: "text-xs font-semibold color-blue-grey" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "p-error" }
const _hoisted_12 = {
  key: 1,
  class: "p-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TabsFormDelivery = _resolveComponent("TabsFormDelivery")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_Textarea = _resolveComponent("Textarea")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_TabsFormDelivery, {
      class: "mb-5",
      options: $setup.tabsOptions,
      onFilterChange: $setup.changePosition,
      position: $setup.positionFilter
    }, null, 8, ["options", "onFilterChange", "position"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("div", _hoisted_4, [
          _createVNode("p", _hoisted_5, _toDisplayString(`Rp. ${$setup.dataForm?.Saldo}`), 1),
          _createVNode("div", _hoisted_6, [
            ($setup.positionFilter === 2)
              ? (_openBlock(), _createBlock("i", _hoisted_7))
              : _createCommentVNode("", true),
            ($setup.positionFilter === 1)
              ? (_openBlock(), _createBlock("i", _hoisted_8))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createVNode("div", null, [
        _createVNode("p", _hoisted_9, _toDisplayString($setup.positionFilter === 1 ? 'Pengurangan' : 'Penambahan') + " Saldo", 1),
        _createVNode(_component_InputNumber, {
          autocomplete: "off",
          class: "input-primary rounded-lg w-full mt-1",
          mode: "currency",
          currency: "IDR",
          locale: "id-ID",
          modelValue: $setup.form.numberSaldo,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ($setup.form.numberSaldo = $event))
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createVNode("div", null, [
      _createVNode("p", {
        class: "font-semibold color-blue-grey text-xs",
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.submit(!$setup.v$.$invalid)))
      }, "Alasan Penyesuaian"),
      _createVNode(_component_Textarea, {
        placeholder: "Tulis Alasan (Wajib)",
        class: "input-grey w-full rounded-lg mt-1",
        modelValue: $setup.v$.reason.$model,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ($setup.v$.reason.$model = $event))
      }, null, 8, ["modelValue"]),
      ($setup.v$.reason.$error && $setup.submitted)
        ? (_openBlock(), _createBlock("span", _hoisted_10, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.v$.reason.$errors, (error, index) => {
              return (_openBlock(), _createBlock("span", {
                id: "new-reason-error",
                key: index
              }, [
                _createVNode("small", _hoisted_11, _toDisplayString(error.$message), 1)
              ]))
            }), 128))
          ]))
        : (($setup.v$.reason.$invalid && $setup.submitted) || $setup.v$.reason.$pending.$response)
          ? (_openBlock(), _createBlock("small", _hoisted_12, _toDisplayString($setup.v$.reason.required.$message), 1))
          : _createCommentVNode("", true)
    ])
  ]))
}